import React from 'react'
import { Popper } from "@material-ui/core";

const CustomMuiPopper: React.FC<any> = (props) => {
  const { placement = "bottom" } = props;
  
  return (
    <Popper
      {...props}
      placement={placement}
      disablePortal={false}
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: "window",
        },
      }}
    />
  );
};

export default CustomMuiPopper;
